import { render, staticRenderFns } from "./cityAdmin.vue?vue&type=template&id=6329e1e6&scoped=true&"
import script from "./cityAdmin.vue?vue&type=script&lang=js&"
export * from "./cityAdmin.vue?vue&type=script&lang=js&"
import style0 from "./cityAdmin.vue?vue&type=style&index=0&id=6329e1e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6329e1e6",
  null
  
)

export default component.exports